/**
* DevExpress Analytics (core\internal\_globalize.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _localization_1 = require("../../property-grid/localization/_localization");
var localization = require("devextreme/localization");
function initGlobalize(settings) {
    var globalize = _localization_1.Globalize;
    if (globalize && settings) {
        settings.cldrSupplemental && globalize.load(settings.cldrSupplemental);
        settings.cldrData && globalize.load(settings.cldrData);
        if (settings.currentCulture) {
            globalize.locale(settings.currentCulture);
            localization['locale'] && localization['locale'](settings.currentCulture);
        }
    }
}
exports.initGlobalize = initGlobalize;
